"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _find2 = _interopRequireDefault(require("lodash/find"));
var _filter2 = _interopRequireDefault(require("lodash/filter"));
var _get2 = _interopRequireDefault(require("lodash/get"));
var _isEmpty2 = _interopRequireDefault(require("lodash/isEmpty"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var _default = exports["default"] = function _default(activity, pawn, session) {
  var childList = [];
  var allChildrenComplete = false;
  if ('acrossChildren' in activity && !('flowUserLists' in activity.acrossChildrenSettings)) {
    childList = (0, _get2["default"])(pawn, activity.acrossChildrenSettings.childrenPath);
    var allChildrenProgress = [];
    // all activity progress
    var hasEmpty = true;
    if ((0, _isEmpty2["default"])((0, _filter2["default"])(childList, function (cl) {
      return (0, _isEmpty2["default"])(cl.flowProgressList);
    }))) {
      hasEmpty = false;
      childList.forEach(function (child) {
        var handleProgress = (0, _find2["default"])(child.flowProgressList, function (fpl) {
          return fpl.flowHandle === activity.flowHandle && fpl.responseSet === session.responseSet;
        });
        if (handleProgress) {
          allChildrenProgress.push(handleProgress);
        }
      });
    }
    if (!hasEmpty && !(0, _isEmpty2["default"])(allChildrenProgress) && (0, _isEmpty2["default"])((0, _filter2["default"])(allChildrenProgress, function (acp) {
      return acp.completed === false;
    }))) {
      allChildrenComplete = true;
    }
  }
  return allChildrenComplete;
};